import { render } from "./DrinksView.vue?vue&type=template&id=3e4c29ec&scoped=true"
import script from "./DrinksView.vue?vue&type=script&lang=js"
export * from "./DrinksView.vue?vue&type=script&lang=js"

import "./DrinksView.vue?vue&type=style&index=0&id=3e4c29ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4c29ec"]])

export default __exports__